import { StyleSheet } from 'react-native';
import { themes } from 'src/theme/theme';

export const styles = StyleSheet.create({
  container: {
    flexGrow: 1,
    gap: 14,
    paddingHorizontal: 16,
    paddingTop: 4,
    backgroundColor: themes.light.gray_blue[7],
  },
  switchSectionsCard: {
    backgroundColor: themes.light.white[1],
    borderRadius: 12,
    borderWidth: 0.1,
    borderColor: themes.light.gray_blue[6],
    flexGrow: 1,
    padding: 14,
  },
  switchSectionsCardContents: {
    gap: 16,
  },
  divider: {
    marginTop: 8,
  },
  childLabel: {
    color: themes.light.gray_blue[3],
  },
  buttonGroupContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    gap: 8, // Add spacing between buttons
  },
  switchButton: {
    flex: 1, // Distribute buttons evenly
  },
});
